const shadowOnlyDraws = new WeakMap();

export function applyModelVistaRendererShadowMode(mesh, mode) {
    mesh.castShadow = mode !== "off";
    mesh.receiveShadow = true;
    const existing = shadowOnlyDraws.get(mesh);
    if (mode !== "shadowsonly") {
        if (existing) {
            mesh.onBeforeRender = existing.before;
            mesh.onAfterRender = existing.after;
            shadowOnlyDraws.delete(mesh);
        }
        return;
    }
    if (existing) return;

    const before = mesh.onBeforeRender, after = mesh.onAfterRender;
    const writes = [];
    // ShadowsOnly is a renderer setting, not a material setting. Scope it to
    // each camera draw so shared/replaced paint stays intact. Three's shadow
    // maps use onBeforeShadow/onAfterShadow and retain their depth writes.
    mesh.onBeforeRender = function (...args) {
        before.apply(this, args);
        const material = args[4];
        writes.push([material, material.colorWrite, material.depthWrite]);
        material.colorWrite = false;
        material.depthWrite = false;
    };
    mesh.onAfterRender = function (...args) {
        const [material, colorWrite, depthWrite] = writes.pop();
        material.colorWrite = colorWrite;
        material.depthWrite = depthWrite;
        after.apply(this, args);
    };
    shadowOnlyDraws.set(mesh, { before, after });
}
